<!-- new theme implementation starts -->

<div class="border bg-white mb15 pad15 position-relative">
    <h4 class="title16 mb15" translate>lblCheckList</h4>
    <ng-container *ngIf="isColorCoded">
        <div class="col-12 mb-3">
          <em class="far fa-circle fa-lg text-info"><label class="ml-2" translate>lblNotChecked</label> </em>
          <em class="far fa-circle fa-lg text-success ml-2"><label class="ml-2" translate>lblChecked</label></em>
          <em class="far fa-circle fa-lg text-danger cursordisable ml-2"><label class="ml-2" translate>lblTobeFixed</label></em>
          <em class="far fa-circle fa-lg text-warning ml-2"><label class="ml-2" translate>lblNeedToBeFix</label></em>
        </div>
    </ng-container>
        <ng-container *ngIf="response?.length>0; else load_elsePart">

            <div class="row">
            <form [formGroup]="editCheckListForm" (ngSubmit)="onSave(editCheckListForm.value)" [class.disabled-form]="isFromArchiveFlag">
                <div class="col-md-12 col-lg-6" [ngClass]="{'col-lg-12': item.checkListItems?.length>3}"
                    *ngFor="let item of response; let i=index">
                    <div class="card dwo-card shadow-none border">
                        <h4 class="title-h5">{{item.subCheckListTitle}}</h4>
                      
                        <table class="tablest1  no-hover pl-0">
                            <thead style="opacity: 0;">
                                <tr>
                                  <th scope="col" colspan="4"></th>
                                    
                                </tr>
                              </thead>
                            <tbody>
                              
                                <ng-container *ngIf="item.checkListItems?.length>0; else load_else">
                                    <tr *ngFor="let subItems of item.checkListItems; let i=index">
                                        <div *ngIf="subItems.isQuestionActive">
                                        <td scope="col" class="thfix pl-0" style="min-width: 300px;">
                                         
                                            {{i+1}}. {{ subItems.subCheckListItemTitle }} </td>
                                        <td>
                                            <div class="d-flex align-items-center">
                                                <ng-container
                                                    *ngIf="subItems.checkListType === 7 || subItems.checkListType === 3 || subItems.checkListType === 5 || subItems.checkListType === 2">
                                                    <input type="text" name="text" [value]="subItems.textBoxValue" (change)="updateDynamicFieldValue(subItems.id, $event.target.value,'textAnswer',null)"
                                                        class="form-control form-control-sm" />
                                                        <button *ngIf="subItems.textBoxValue" class="btn btn-link ml-2" (click)="copyTextDetail(subItems.textBoxValue)" placement="top"
                                                        ngbTooltip="{{'lblCopy' | translate}}" aria-label="Center Align">
                                                        <em class="fas fa-copy fa-lg"></em>
                                                      </button>
                                                </ng-container>
                                            </div>

                                        </td>
                                        
                                        <td class="px-0" >

                                            <div class="d-flex flex-wrap form-check pl-0">
                                                <div class="d-flex flex-wrap pr-2 w-100">
                                                    <div *ngFor="let option of subItems.checkListItemType">
                                                        <label class="mr10 d-inline-block" style="max-width:225px;">
                                                            <input type="checkbox" name="option.checkboxTitle"
                                                                value="option.checkboxTitle"
                                                                (change)="updateDynamicFieldValue(option.id, $event.target.checked,'checkAnswer',subItems.checkListItemType)"
                                                                [checked]="option.checkBoxValue" />
                                                            {{option.checkboxTitle}}
                                                        </label>
                                                    </div>                                                   
                                                </div>

                                                    <div class="d-flex flex-wrap " style="min-width: 250px;">                                                   
                                                        <div class="d-inline-block mr-2" *ngFor="let option of subItems.checkListRadioItemType">
                                                            <div *ngIf="option.color == null">
                                                            <label class="mr10" style="max-width:225px;">
                                                                <input type="radio" class="radio-custom" 
                                                                    value="option.radioButtonValue"
                                                                    (change)="updateDynamicFieldValue(option.id, $event.target.checked, 'radioAnswer',subItems.checkListRadioItemType)"
                                                                    [checked]="option.radioButtonValue" />
                                                                {{option.radioButtonTitle}}
                                                            </label>
                                                            </div>
                                                        </div>
                                                    </div>

                                                <div class="d-flex flex-wrap " style="min-width: 250px;">                                                   
                                                    <ng-container *ngFor="let clr of lstPredefinedColors;">
                                                        <ng-container *ngFor="let option of subItems.checkListRadioItemType;">
                                                            <div class="d-inline-block mr-2" *ngIf="option.color == clr">
                                                                <label class="mr10" style="max-width:225px;">
                                                                    <input type="radio" class="radio-custom"  
                                                                    [style.border-color]="option.color"
                                                                    name="{{option.parentId}}"
                                                                    (change)="updateDynamicFieldValue(option.id, $event.target.checked, 'radioAnswer',subItems.checkListRadioItemType)"
                                                                    [checked]="option.radioButtonValue"
                                                                    style="border-width: 2px;" 
                                                                    />
                                                                    {{item.isMulticolorCheckListSelected ? null : option.radioButtonTitle}}
                                                                </label>
                                                            </div>
                                                        </ng-container>
                                                    </ng-container>
                                                </div>


                                            </div>

                                        </td>
                                        <td class="pl-0">
                                            <ng-container *ngIf="subItems.makeCameraAvailable">
                                                <button type="button" class="relative pl-0" readonly aria-label="Center Align"><em
                                                        class="fas fa-upload"></em>
                                                    <span
                                                        class="badge badge-primary top background">{{subItems.fileCount}}</span></button>
                                            </ng-container>
                                        </td>
                                    </div>
                                    </tr>
                                    
                                    
                                </ng-container>
                                <ng-template #load_else>
                                    <tr>
                                        <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                                    </tr>
                                </ng-template>
                            </tbody>
                            
                        </table>

                    </div>
                </div>
                <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
                    <button type="submit" class="btn btn-primary btn-lg mr-sm-2"
                            [disabled]="isFromArchiveFlag || !editCheckListForm.valid" translate
                            aria-label="Center Align">
                      lblUpdate
                    </button>
                    <a (click)="Cancelform('Payer')" class="btn btn-secondary btn-lg" translate>lblCancel</a>
                </div>
            </form>
            </div>

            

        </ng-container>
        

        <ng-template #load_elsePart>
            
                
                    <div class="no-record" translate>lblNoCheckListFound</div>
                
            

        </ng-template>
      


</div>
<!-- new theme implementation ends -->